<script setup lang="ts">
    const $emit = defineEmits<{
        (e: 'before-open', payload: any): void;
        (e: 'opened', payload: any): void;
        (e: 'before-close', payload: any): void;
        (e: 'closed', payload: any): void;
    }>();

    const props = defineProps({
        model: {
            required: true,
        },
        modalStyle: {
            type: String,
            default: 'centered',
        },
        scrollable: {
            required: false,
            type: Boolean,
            default: false,
        },
    });

    const modal = ref(null);
</script>

<template>
    <Modal
        ref="modal"
        :name="`${model.prefix}:form-modal`"
        :scrollable="scrollable"
        :modal-style="modalStyle"
        @before-open="$emit('before-open')"
        @opened="$emit('opened')"
        @before-close="$emit('before-close')"
        @closed="$emit('closed')"
    >
        <slot></slot>
    </Modal>
</template>
